import { BaseDO } from "../base.model";
import { ProposalCoverageInsuredDO } from "./proposalCoverageInsuredDO";
import { ProposalCoverageScheduleDO } from "./proposalCoverageScheduleDO";

export class ProposalCoverageDO extends BaseDO {
    
    public baseAnnualPremium: null;
    public getbaseAnnualPremium(): null {
        return this.baseAnnualPremium;
    }
    public setbaseAnnualPremium(value: null) {
        this.baseAnnualPremium = value;
    }
    
    public sumInsuredAmt: Number = null;
    public getsumInsured(): Number {
        return this.sumInsuredAmt;
    }
    public setsumInsured(value: Number) {
        this.sumInsuredAmt = value;
    }
    
    public paymentFrequencyCd: String = null;
    public getpaymentFrequencyCd(): String {
        return this.paymentFrequencyCd;
    }
    public setpaymentFrequencyCd(value: String) {
        this.paymentFrequencyCd = value;
    }
    
    public policyTerm: Number = null;
    public getproposalTerm(): Number {
        return this.policyTerm;
    }
    public setproposalTerm(value: Number) {
        this.policyTerm = value;
    }
    
    public planOptionCd: String = null;
    public getplanOptionCd(): String {
        return this.planOptionCd;
    }
    public setplanOptionCd(value: String) {
        this.planOptionCd = value;
    }
    
    public productTypeCd: String = null;
    public getproductTypeCd(): String {
        return this.productTypeCd;
    }
    public setproductTypeCd(value: String) {
        this.productTypeCd = value;
    }
    
    public productCd: String = null;
    public getproductCd(): String {
        return this.productCd;
    }
    public setproductCd(value: String) {
        this.productCd = value;
    }
    
    public planTypeCd: String = null;
    public getplanTypeCd(): String {
        return this.planTypeCd;
    }
    public setplanTypeCd(value: String) {
        this.planTypeCd = value;
    }
    
    public proposalCoverageInsureds: ProposalCoverageInsuredDO[] = [];
    public getproposalCoverageInsureds(): ProposalCoverageInsuredDO[] {
        return this.proposalCoverageInsureds;
    }
    public setproposalCoverageInsureds(value: ProposalCoverageInsuredDO[]) {
        this.proposalCoverageInsureds = value;
    }
    
    public proposalCoverageSchedules: ProposalCoverageScheduleDO[] = [];
    public getproposalCoverageSchedules(): ProposalCoverageScheduleDO[] {
        return this.proposalCoverageSchedules;
    }
    public setproposalCoverageSchedules(value: ProposalCoverageScheduleDO[]) {
        this.proposalCoverageSchedules = value;
    }
    
    public commencementDt: Date = null;
    public getcommencementDt(): Date {
        return this.commencementDt;
    }
    public setcommencementDt(value: Date) {
        this.commencementDt = value;
    }
    
    public expiryDt: Date = null;
    public getexpiryDt(): Date {
        return this.expiryDt;
    }
    public setexpiryDt(value: Date) {
        this.expiryDt = value;
    }
}